import isBrowser from 'utils/isBrowser';

export function removeUrlParam(paramName) {
	if (isBrowser()) {
		const newUrl = new URL(globalThis.location.href);
		newUrl.searchParams.delete(paramName);
		globalThis.history.replaceState({}, '', newUrl.toString());
	}
}

export const setLocation = (path, timeout = 300) => {
	if (isBrowser()) {
		// Wait 300ms for any tracking events to flush
		setTimeout(() => {
			globalThis.location.href = path;
		}, timeout);
	}
};
